import React, { useRef } from "react";
import Input from "./Input";

export default function UserSearch() {
  const emailId = useRef();

  return (
    <div className="mt-6">
      {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center items-center mt-0 ">
        <div className="border p-24 rounded-lg bg-gray-100">
          <h1 className="text-4xl text-blue-complimentary mb-6 font-semibold">
            Search For your account information
          </h1>
          <h1 className="text-lg text-blue-complimentary ml-1 text-left">
            Enter the FIRST part of your email before the @domain.com
          </h1>
          <Input emailId={emailId} />
          <button
            onClick={() => {
              //   submitEmailId();
            }}
            type="button"
            className="mt-3 inline-flex items-center px-6 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-complement focus:ring-opacity-50"
          >
            Find Account
          </button>
        </div>
      </div> */}
    </div>
  );
}
